import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const Clamp = ({ lines, children, className }) => {
  return (
    <>
      <div className={classNames('clamp', className)}>{children}</div>
      <style jsx>{`
        .clamp {
          display: -webkit-box;
          -webkit-line-clamp: ${lines};
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
      `}</style>
    </>
  );
};

Clamp.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  lines: PropTypes.number,
};

Clamp.defaultProps = {
  lines: 4,
};

export default Clamp;
